import { createContext } from "react";

const HelpdeskContext = createContext();

export default HelpdeskContext;
